import React from "react";
import { Loader2, Mic, MicOff, Send } from "lucide-react";

const VOICE_TITLE = { et: "Häälsisestus", ru: "Голосовой ввод", en: "Voice input" };
const LISTENING_PLACEHOLDER = { et: "Kuulan…", ru: "Слушаю…", en: "Listening…" };

/**
 * Input bar for the AI Assistant panel: text input + optional voice-to-text
 * mic button + send button. Kept purely presentational — the parent owns the
 * value/onChange, voice state, and submit handler.
 */
export default function InputBar({
  lang,
  value,
  onChange,
  onSubmit,
  busy,
  placeholder,
  sendLabel,
  voice, // { supported, listening, toggle }
}) {
  return (
    <form
      onSubmit={onSubmit}
      className="flex items-center gap-2 px-4 py-4 border-t border-surface-outline/40 bg-white/70"
      data-testid="ai-input-form"
    >
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={voice.listening ? (LISTENING_PLACEHOLDER[lang] || LISTENING_PLACEHOLDER.et) : placeholder}
        disabled={busy}
        data-testid="ai-input"
        className="flex-1 px-4 py-3 rounded-xl bg-white border border-surface-outline/60 text-[14px] focus:outline-none focus:border-sapphire-500 focus:ring-2 focus:ring-teal-200/40"
      />
      {voice.supported && (
        <button
          type="button"
          onClick={voice.toggle}
          disabled={busy}
          data-testid="ai-voice-btn"
          aria-label={voice.listening ? "Stop listening" : "Voice input"}
          title={VOICE_TITLE[lang] || VOICE_TITLE.et}
          className={`h-11 w-11 rounded-xl flex items-center justify-center transition-colors disabled:opacity-50 ${
            voice.listening
              ? "bg-red-500 text-white animate-pulse-ring"
              : "bg-teal-200/60 text-teal-500 hover:bg-teal-200"
          }`}
        >
          {voice.listening ? <MicOff className="h-5 w-5" /> : <Mic className="h-5 w-5" />}
        </button>
      )}
      <button
        type="submit"
        disabled={busy || !value.trim()}
        data-testid="ai-send-btn"
        className="h-11 w-11 rounded-xl bg-sapphire-700 text-white flex items-center justify-center disabled:opacity-50 hover:bg-sapphire-600 transition-colors"
        aria-label={sendLabel}
      >
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Send className="h-5 w-5" />}
      </button>
    </form>
  );
}
